module.exports = __webpack_public_path__ + "55d752aac34efa9f08f26d2c875b90ca.pdf";